import UsersConfig from './users.config';
import UsersController from './users.controller';
import StartUsersController from './start.users.controller';
import LoginUsersController from './login.users.controller';
import SelectResourceUsersController from './select-resource.users.controller';
import AdditionalDataUsersController from './additional-data.users.controller';
import TooManyFailedLoginsUsersController from './too-many-failed-logins.users.controller';
import ProfileUsersController from './profile.users.controller'
import ErrorUsersController from './error.users.controller';
import ChangePasswordUsersController from './changePassword.users.controller'
import PolicyController from './policy.controller'
import UsersWrapperDirective from './directives/users-wrapper';
import PolicyDirective from './directives/policy';
import PasswordDirective from './directives/password';
import CountryCodeDirective from './directives/country-code';
import NewPasswordDirective from './directives/new-password';

let usersModule = angular.module('ff.users', []);

usersModule.config(UsersConfig);
usersModule.controller('UsersController', UsersController);
usersModule.controller('StartUsersController', StartUsersController);
usersModule.controller('LoginUsersController', LoginUsersController);
usersModule.controller('SelectResourceUsersController', SelectResourceUsersController);
usersModule.controller('AdditionalDataUsersController', AdditionalDataUsersController);
usersModule.controller('TooManyFailedLoginsUsersController', TooManyFailedLoginsUsersController);
usersModule.controller('ErrorUsersController', ErrorUsersController);
usersModule.controller('ProfileUsersController', ProfileUsersController);
usersModule.controller('ChangePasswordUsersController', ChangePasswordUsersController);
usersModule.controller('PolicyController', PolicyController);
usersModule.directive('usersWrapper', UsersWrapperDirective);
usersModule.directive('policy', PolicyDirective);
usersModule.directive('password', PasswordDirective);
usersModule.directive('countryCode', CountryCodeDirective);
usersModule.directive('newPassword', NewPasswordDirective);

export default usersModule = usersModule.name



// WEBPACK FOOTER //
// ./src/users/users.module.js